const SETTINGS = {
  HOME: 'https://api.babacuais.eita.coop.br',
  METABASE: {
    URL: 'https://metabase.babacuais.eita.coop.br',
    SECRET_KEY: 'f64047fe24f108e17b650e2580af572469c8b8a58dad6a8898c54af28ac86c9c',
    EMAIL: 'coletivo@eita.org.br',
  },
};

export default SETTINGS;
